<template>
  <div>
    <SidebarSearch
      @submit="submitForm"
      @clear="clearForm"
    >
      <SearchCollapse
        :expanded="true"
        title="Dados Gerais"
      >
        <NxInputDocument
          @update:value="handleInputUpdate('document', $event)"
        />
        <NxInputName @update:value="handleInputUpdate('nome', $event, false)" />
        <NxInput
          name="numProtocolo"
          type="text"
          label="Número do Protocolo:"
          placeholder="Digite o Número do Protocolo:"
          @update:value="handleInputUpdate('numProtocolo', $event, false)"
        ></NxInput>
      </SearchCollapse>

      <SearchCollapse title="Instituição">
        <NxSelectPA @update:value="handleSelectUpdate('paIds', $event)" />
        <NxSelectRegional
          @update:value="handleSelectUpdate('nomeRegional', $event)"
        />
        <NxSelectFuncionario
          :variable="employeeTypes.GERENTE"
          @update:value="handleSelectUpdate('gerenteId', $event)"
        />
      </SearchCollapse>

      <SearchCollapse title="Responsável">
        <NxSelectFuncionario
          :variable="employeeTypes.RESPONSAVEL"
          @update:value="handleSelectUpdate('responsavelId', $event)"
        />
        <NxSelectResponsavelGrupo
          @update:value="handleSelectUpdate('gruposResponsaveisId', $event)"
        />
      </SearchCollapse>

      <SearchCollapse title="Produto">
        <NxSelectProduto
          @update:value="handleSelectUpdate('produtosId', $event)"
        />
        <NxInputMoneyRange
          @update:InitialValue="
            handleInputUpdate('valorInicial', $event, false)
          "
          @update:FinalValue="handleInputUpdate('valorFinal', $event, false)"
        />
      </SearchCollapse>
      <SearchCollapse title="Geral">
        <NxSelectQuadro @update:value="handleSelectUpdate('boardId', $event)" />
        <!-- ORIGEM AND SITUACAO ARE NOT MADE -->
        <NxSelectOrigem
          @update:value="handleSelectUpdate('origensId', $event)"
        />
        <NxSelectSituacao
          @update:value="handleSelectUpdate('situacao', $event)"
        />
        <NxInputDateRange
          label="Data de Abertura Oportunidade:"
          @update:InitialValue="
            handleInputDateUpdate('dataInicial', $event, false)
          "
          @update:FinalValue="handleInputDateUpdate('dataFinal', $event, false)"
        />
      </SearchCollapse>
      <SearchCollapse title="Ajuizamento">
        <NxInputDateRange
          label="Período de Distribuição:"
          @update:InitialValue="
            handleInputDateUpdate('dataDistribuicaoInicial', $event, false)
          "
          @update:FinalValue="handleInputDateUpdate('dataDistribuicaoFinal', $event, false)"
        />
        <NxInput
          name="numProcesso"
          type="text"
          label="Número do processo:"
          placeholder="Digite o Número do Processo:"
          @update:value="handleInputUpdate('numeroProcesso', $event, false)"
        ></NxInput>
        <NxSelectAjuizamentoAdvogado
          labelText="Advogado Responsável:"
          @update:value="handleSelectUpdate('advogadoResponsavel', $event)"
        />
        <NxSelectAjuizamentoAdvogado
          labelText="Advogado Contrário:"
          @update:value="handleSelectUpdate('advogadoContrario', $event)"
        />
        <NxSelectAjuizamentoAssunto
          @update:value="handleSelectUpdate('assuntoId', $event)"
        />
        <NxSelectAjuizamentoComarca
          @update:value="handleSelectUpdate('comarcaId', $event)"
        />
        <NxSelectAjuizamentoFase
          @update:value="handleSelectUpdate('faseId', $event)"
        />
        <NxSelectAjuizamentoObjetoAcao
          @update:value="handleSelectUpdate('objetoAcaoId', $event)"
        />
        <NxSelectAjuizamentoPrognostico
          @update:value="handleSelectUpdate('prognosticoId', $event)"
        />
      </SearchCollapse>
    </SidebarSearch>
  </div>
</template>

<script>
import {
  NxInputDateRange,
  NxInputDocument,
  NxInputMoneyRange,
  NxInputName,
  NxInputNumberRange
} from '@/components/nexum/components/custom-inputs/index.js'
import {
  NxSelectFuncionario,
  NxSelectOrigem,
  NxSelectPA,
  NxSelectProduto,
  NxSelectQuadro,
  NxSelectRegional,
  NxSelectResponsavelGrupo,
  NxSelectSituacao,
  NxSelectAjuizamentoAdvogado,
  NxSelectAjuizamentoAssunto,
  NxSelectAjuizamentoComarca,
  NxSelectAjuizamentoFase,
  NxSelectAjuizamentoObjetoAcao,
  NxSelectAjuizamentoPrognostico
} from '@/components/nexum/components/custom-selects/index.js'
import SidebarSearch from '@/containers/layout/sidebars/SidebarSearch.vue'
import SearchCollapse from '@/containers/layout/sidebars/components/SearchCollapse.vue'
import employeeTypes from '@/enums/enumEmployeeTypes.js'
import riskTypes from '@/enums/enumRiskTypes.js'

export default {
  name: 'SidebarRelatorioAjuizamento',
  components: {
    SidebarSearch,
    SearchCollapse,
    NxSelectPA,
    NxSelectRegional,
    NxSelectFuncionario,
    NxSelectResponsavelGrupo,
    NxSelectProduto,
    NxSelectQuadro,
    NxSelectOrigem,
    NxSelectSituacao,
    NxInputDocument,
    NxInputName,
    NxInputMoneyRange,
    NxInputNumberRange,
    NxInputDateRange,
    NxSelectAjuizamentoAssunto,
    NxSelectAjuizamentoComarca,
    NxSelectAjuizamentoAdvogado,
    NxSelectAjuizamentoFase,
    NxSelectAjuizamentoObjetoAcao,
    NxSelectAjuizamentoPrognostico
  },
  data () {
    return {
      // Form data devem seguir as nomenclaturas esperadas pelo backend
      form: {
        nome: null,
        document: null,
        paIds: null,
        nomeRegional: null,
        gerenteId: null,
        responsavelId: null,
        gruposResponsaveisId: null,
        produtosId: null,
        valorInicio: null,
        valorFinal: null,
        quadrosId: null,
        origensId: null,
        situacao: null,
        dataInicial: null,
        dataFinal: null,
        numProtocolo: null,
        dataDistribuicaoInicial: null,
        dataDistribuicaoFinal: null,
        numeroProcesso: null,
        advogadoResponsavel: null,
        advogadoContrario: null
      },
      riskTypes: riskTypes,
      employeeTypes: employeeTypes
    }
  },
  methods: {
    debugLog () {
      console.log(this.form)
    },
    submitForm () {
      // TODO: encode the name before sendind it
      // this.form.nome = encodeURIComponent(this.form.nome)
      this.$nextTick(() => {
        this.$emit('search', this.form)
      })
    },
    clearForm () {
      this.$root.$emit('clearForm')
      this.$nextTick(() => {
        this.submitForm()
      })
    },
    clearField (field) {
      this.form[field] = null
    },
    encodeSpecialChar (dataPropName, value) {
      console.log(this.form.nome)
      this.form[dataPropName] = encodeURIComponent(value)
      console.log(this.form.nome)
    },
    handleSelectUpdate (fieldName, selectedValue) {
      // If input comes as a string or a number
      if (
        typeof selectedValue === 'string' ||
        typeof selectedValue === 'number'
      ) {
        this.form[fieldName] = selectedValue
        return
      }
      // If to clear multiple select
      if (Array.isArray(selectedValue) && !selectedValue.length) {
        this.clearField(fieldName)
        return
      }
      // If to clear single select and update both types
      if (selectedValue) {
        this.form[fieldName] = Array.isArray(selectedValue)
          ? selectedValue.map((v) => (v.hasOwnProperty('value') ? v.value : v))
          : selectedValue.hasOwnProperty('value')
            ? selectedValue.value
            : selectedValue
      } else {
        this.clearField(fieldName)
      }
    },
    handleInputUpdate (fieldName, inputedValue, clean = true) {
      if (inputedValue) {
        this.form[fieldName] = clean
          ? inputedValue.replace(/[^a-zA-Z0-9 ]/g, '')
          : inputedValue
      } else {
        this.clearField(fieldName)
      }
    },
    handleInputDateUpdate (fieldName, inputedValue) {
      if (inputedValue) {
        let newDate = new Date(inputedValue)
        this.form[fieldName] = newDate
      } else {
        this.clearField(fieldName)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/reports/ajuizamento/search/SidebarRelatorioAjuizamento.vue